import { turkishToLower } from '../../utils/stringUtils';
import { parseKanunMaddesi, secimEslesirMi } from '../../utils/kanunMaddeParse';

// Şablonların kanun_maddeleri parse sonuçlarını önbelleğe al (raw string -> parsed).
// Anahtar küme DB'deki farklı etiket sayısıyla sınırlı; parse her etiket için bir kez.
const parseCache = new Map();
function parseliMaddeler(sablon) {
  if (!Array.isArray(sablon.kanun_maddeleri)) return [];
  return sablon.kanun_maddeleri.map((m) => {
    const raw = typeof m === 'string' ? m : (m && (m.value != null ? m.value : m.label)) || '';
    let p = parseCache.get(raw);
    if (!p) {
      p = parseKanunMaddesi(raw);
      parseCache.set(raw, p);
    }
    return p;
  });
}

export function filtreliSablonlariGetir(sablonlar, secilenKategoriler, secilenEtiketler, secilenKanunMaddeleri, aramaMetni) {
  const aramaMetniKucuk = turkishToLower(aramaMetni || '');
  // Hiçbir kategori seçili değilse filtre yok (= hepsi). Etiket/kanun filtreleriyle aynı mantık.
  const tumKategorilerSecili = secilenKategoriler.length === 0;
  const kategorisizSecili = secilenKategoriler.includes('Kategorisiz');
  
  return sablonlar.filter(sablon => {
    const kategoriKosulu = tumKategorilerSecili || 
      (kategorisizSecili && (!sablon.kategoriler || sablon.kategoriler.length === 0)) ||
      (sablon.kategoriler && sablon.kategoriler.some(kategori => secilenKategoriler.includes(kategori.isim)));
    
    const etiketKosulu = secilenEtiketler.length === 0 || 
      (sablon.etiketler && secilenEtiketler.every(etiket => sablon.etiketler.includes(etiket)));
    
    // Her seçim kendi seviyesinde bir yüklem (kanun/madde/varyant); seçimler arası VE.
    const kanunMaddesiKosulu = secilenKanunMaddeleri.length === 0 || (() => {
      const parsedlar = parseliMaddeler(sablon);
      return secilenKanunMaddeleri.every(token => parsedlar.some(p => secimEslesirMi(p, token)));
    })();
    
    const aramaKosulu = !aramaMetniKucuk || 
      turkishToLower(sablon.baslik).includes(aramaMetniKucuk) ||
      (sablon.etiketler && sablon.etiketler.some(etiket => turkishToLower(etiket).includes(aramaMetniKucuk))) ||
      (sablon.icerik && turkishToLower(sablon.icerik).includes(aramaMetniKucuk));

    return kategoriKosulu && etiketKosulu && kanunMaddesiKosulu && aramaKosulu;
  });
}
